import { render, staticRenderFns } from "./SolicitacoesResumo.vue?vue&type=template&id=76bb7cb6&scoped=true"
import script from "./SolicitacoesResumo.vue?vue&type=script&lang=js"
export * from "./SolicitacoesResumo.vue?vue&type=script&lang=js"
import style0 from "./SolicitacoesResumo.vue?vue&type=style&index=0&id=76bb7cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bb7cb6",
  null
  
)

export default component.exports